import classNames from "classnames";
import React from "react";

import defaultStyles from "@stadium/ui/src/components/ProfileDropdown/main.module.scss";
import ExternalButton from "@stadium/ui/src/components/button/external-button";

import { FeatureFlagWrapper } from "@stadium/services/launch-darkly";

import { HELP_CENTER_URL } from "@stadium/constants/routes";
import { workspaceSidebarFlag } from "@stadium/services/launch-darkly/constants";

const ProfileDropdownBody = ({
  className = "",
  programList = null,
  styles = defaultStyles,
  logoutButton,
  banner,
  email = "",
  emailAtBottom = "",
  userName,
  showHelpCenterCta = true,
  isNewSwagmagicHost = false,
  helpCenterCta,
}) => {
  const renderHelpCenterCta = () => {
    if (!showHelpCenterCta) return;
    if (helpCenterCta) return helpCenterCta;
    return (
      <ExternalButton btnStyle="link" href={HELP_CENTER_URL} className={styles.profileHelpButton}>
        <span className={styles.iconHelp}></span>
        <span className={styles.profileHelpButtonText}>Help Center</span>
      </ExternalButton>
    );
  };
  return (
    <div className={`${styles.userDropdownMenuContainer} ${className}`}>
      <FeatureFlagWrapper
        fallback={email && <div className={styles.userDropdownEmailRow}>{email}</div>}
        flag={workspaceSidebarFlag}
      >
        {email && (
          <div className={classNames(styles.userInfo, styles.userInfoNavNew)}>
            {userName && <div className={styles.userName}>{userName}</div>}
            {email && <div className={styles.userEmail}>{email}</div>}
          </div>
        )}
      </FeatureFlagWrapper>
      <div
        className={`${styles.userDropdownMenuRow} ${
          isNewSwagmagicHost ? styles.userDropdownMenuRowSW : ""
        }`}
      >
        {programList}
        <div className={`${styles.userDropdownMenuCol} ${styles.profileBannerContainer}`}>
          <div className={styles.responsiveBannerWidth}>{banner}</div>
        </div>
        {emailAtBottom && <div className={styles.userEmail}>{emailAtBottom}</div>}
        <div
          className={`${styles.userDropdownMenuColFull} ${
            isNewSwagmagicHost ? styles.userDropdownMenuColFullSW : ""
          }`}
        >
          {renderHelpCenterCta()}
          <div className={styles.logoutButtonContainer}>{logoutButton}</div>
        </div>
      </div>
    </div>
  );
};

export default ProfileDropdownBody;
